const styles = {
  mobile: {
    display: "none",
    "@media (max-width: 1200px)": {
      display: "block",
    },
  },
  desktop: {
    display: "block",
    "@media (max-width: 1200px)": {
      display: "none",
    },
  },
};

export default styles;
